import { styled } from "@mui/material";

const MessageViewerContainer = styled("div")`
  margin-top: -16px;
`;

export { MessageViewerContainer };
